


























import AbstractAnimateDropdown
  from '@/components/abstractDropdowns/AbstractAnimateDropdown/Dropdown.vue';
import baseDropdown from '@/mixins/baseDropdown';
import { Component, Model, Prop } from 'vue-property-decorator';

@Component({
  name: 'BaseSelector',
  components: {
    AbstractAnimateDropdown,
  },
})
export default class BaseSelector extends baseDropdown {
  @Model('input', {
    type: Number,
    required: true,
  })
  private value!: number;

  @Prop({
    type: Number,
    required: true,
  })
  maxValue!: number;

  @Prop({
    type: Number,
    required: true,
  })
  minValue!: number;

  private contentAttrs: any = {
    class: 'droplist fourcolls'
  };

  private get possibleValues(): number[] {
    const possibleValues = [];

    for (let i = this.minValue; i <= this.maxValue; i++) {
      possibleValues.push(i);
    }

    return possibleValues;
  }

  private selectValue(value: number) {
    this.$emit('input', value);
  }
}
